import React from 'react';
import Typography from 'material-ui/Typography/Typography';
import LastPerformanceMenu from './LastPerformanceMenu';

const LastPerformanceValue = props => {
    const {
        value,
        savedWorkoutSetExercise,
        applyPrescription,
        isSubscription
    } = props;

    if (!value) {
        return (
            <div className="lastPerformance">
                <div className="title">LAST</div>
                <Typography variant="body2" className="emptyState">
                    No data logged
                </Typography>
            </div>
        );
    }

    return (
        <div className="lastPerformance">
            <LastPerformanceMenu
                isSubscription={isSubscription}
                applyPrescription={applyPrescription}
                savedWorkoutSetExercise={savedWorkoutSetExercise}
            />
            <div className="title">LAST</div>
            <Typography variant="body2" className="value">
                {value}
            </Typography>
        </div>
    );
};

export default LastPerformanceValue;
